module.exports = __webpack_public_path__ + "static/media/studio_queue.d98e0230.svg";